$('#billing_phone_field, #billing_email_field, #billing_postcode_field, #billing_state_field').removeClass('form-row-wide');
